import { useTranslation } from '@mint-lib/i18n';
import { usePermissions } from '@mint-lib/profile-helpers';
import styled from '@mint-lib/styled';

import { Box, Button as MuiButton } from '@myn/mui';

import { FeaturePermissionsConstants } from '../../../../../../constants/FeaturePermissionsConstants.js';

type Props = {
  onClickOpenVersion: () => void;
  onClickDuplicateVersion: () => void;
  canBeDuplicated?: boolean;
  onClickAddNotes: () => void;
  onClickDeleteVersion: () => void;
  canBeDeleted?: boolean;
  isOpeningDisabled?: boolean;
};

const ActionsFieldModal = ({
  onClickAddNotes,
  onClickDuplicateVersion,
  canBeDuplicated,
  onClickOpenVersion,
  onClickDeleteVersion,
  canBeDeleted,
  isOpeningDisabled,
}: Props) => {
  const { t } = useTranslation('@myn/planning');
  const { permissions } = usePermissions();

  const access =
    permissions?.campaignPlanningFeature ===
      FeaturePermissionsConstants.FULL_CONTROL || false;
  return (
    <StyledModalContainer>
      <MuiButton
        startIcon="ArrowRight"
        variant="text"
        onClick={onClickOpenVersion}
        disabled={isOpeningDisabled}
      >
        {t('Open version')}
      </MuiButton>
      <MuiButton
        startIcon="Copy"
        variant="text"
        onClick={onClickDuplicateVersion}
        disabled={!canBeDuplicated || !access}
      >
        {t('Clone')}
      </MuiButton>
      <MuiButton
        startIcon="Chat"
        variant="text"
        onClick={onClickAddNotes}
        disabled={!access}
      >
        {t('Add notes')}
      </MuiButton>
      <MuiButton
        startIcon="Delete"
        variant="text"
        onClick={onClickDeleteVersion}
        disabled={!canBeDeleted || !access}
      >
        {t('Delete version')}
      </MuiButton>
    </StyledModalContainer>
  );
};

const StyledModalContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 228px;
  height: 100%;
  box-shadow: 0px 6px 16px rgba(42, 49, 102, 0.16);
  border-radius: 6px;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(1)};
`;

export default ActionsFieldModal;
